// extracted by mini-css-extract-plugin
module.exports = {"container":"PremiumBanner_container__efx6n","fancy":"PremiumBanner_fancy__83IVq","button":"PremiumBanner_button__2j8kz"};